const STORAGE = {
  baseUrl: 'hfh_admin_base',
  token: 'hfh_admin_token',
  admin: 'hfh_admin_user',
};

const DEFAULT_BASE_URL = 'https://b2bhashtagfashion.com';

const normalizeBaseUrl = (value) => {
  const raw = String(value || '').trim();
  const fallback = DEFAULT_BASE_URL;
  if (!raw) return fallback;
  let normalized = raw.replace(/\/+$/, '');
  normalized = normalized.replace(/\/api$/i, '');
  if (
    /^https?:\/\/192\.168\./i.test(normalized) ||
    /^https?:\/\/10\./i.test(normalized) ||
    /^https?:\/\/127\.0\.0\.1(?::\d+)?$/i.test(normalized) ||
    /^https?:\/\/localhost(?::\d+)?$/i.test(normalized)
  ) {
    return fallback;
  }
  return normalized;
};

export const getBaseUrl = () =>
  normalizeBaseUrl(localStorage.getItem(STORAGE.baseUrl) || DEFAULT_BASE_URL);

export const setBaseUrl = (value) =>
  localStorage.setItem(STORAGE.baseUrl, normalizeBaseUrl(value));

export const getMediaUrl = (value) => {
  if (!value) return '';
  const raw =
    typeof value === 'string'
      ? value
      : value?.$oid || value?.id || value?.path || String(value);
  if (!raw) return '';

  if (/^https?:\/\//i.test(raw)) return raw;
  if (raw.startsWith('/api/media/')) return `${getBaseUrl()}${raw}`;
  if (raw.startsWith('/media/')) return `${getBaseUrl()}${raw}`;

  const cleaned = String(raw).replace(/^\/+/, '').replace(/\/+$/, '');
  return `${getBaseUrl()}/api/media/${cleaned}/`;
};

export const getToken = () => localStorage.getItem(STORAGE.token);
export const setToken = (token) => localStorage.setItem(STORAGE.token, token);
export const clearToken = () => localStorage.removeItem(STORAGE.token);

export const setAdmin = (value) =>
  localStorage.setItem(STORAGE.admin, JSON.stringify(value || {}));
export const getAdmin = () => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE.admin) || '{}');
  } catch {
    return {};
  }
};

export const requestJson = async (method, path, body, auth = true) => {
  const headers = { 'Content-Type': 'application/json' };
  if (auth && getToken()) {
    headers.Authorization = `Bearer ${getToken()}`;
  }
  const endpoint = `${getBaseUrl()}${path.startsWith('/') ? path : `/${path}`}`;
  let res;
  try {
    res = await fetch(endpoint, {
      method,
      headers,
      body: body ? JSON.stringify(body) : undefined,
    });
  } catch (e) {
    throw new Error(`Network error for ${endpoint}`);
  }
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(text || `Request failed: ${res.status}`);
  }
  return res.json();
};

export const requestForm = async (path, formData, auth = true, method = 'POST') => {
  const headers = {};
  if (auth && getToken()) {
    headers.Authorization = `Bearer ${getToken()}`;
  }
  const endpoint = `${getBaseUrl()}${path.startsWith('/') ? path : `/${path}`}`;
  let res;
  try {
    res = await fetch(endpoint, {
      method,
      headers,
      body: formData,
    });
  } catch (e) {
    throw new Error(`Network error for ${endpoint}`);
  }
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(text || `Request failed: ${res.status}`);
  }
  return res.json();
};
